import logUtil from 'utils/log'

export default function removeMainContentPaddingDomUtil () {
  logUtil('removeMainContentPaddingDomUtil').debug('[start]')
  const main = document.querySelector('main')
  if (!main) {
    logUtil('removeMainContentPaddingDomUtil').debug('[noop] no main')
    return
  }
  main.style.padding = '0'
}
